import angular from 'angular';

module.exports = angular.module('common.values', [
  require('./inspector-crews'),
  require('./mapbox-config'),
  require('./timezone'),
  require('./work-order-time-estimate-types'),
]).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/values/index.js
 **/